import { addDays, addHours, format } from 'date-fns';
const dayNameToNumber: { [key: string]: number } = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};
export const getToolOrderRequiredDate = (startDate: Date, noOfDaysRequiredAfter: number, weekEndDays: string[]) => {
  const weekendDays = weekEndDays.map((day) => dayNameToNumber[day.toLocaleUpperCase()]);
  let daysAdded = 0;
  const minExpectedDate = new Date(startDate);
  while (daysAdded < noOfDaysRequiredAfter) {
    minExpectedDate.setDate(minExpectedDate.getDate() + 1); // Move to the next day
    // Check if the current day is not in the custom weekend days
    const dayOfWeek = minExpectedDate.getDay();
    if (!weekendDays.includes(dayOfWeek)) {
      daysAdded++;
    }
  }
  return minExpectedDate; //Adding one hour here in required date
};
export const getHoursDifferenceExcludingCustomWeekends = (
  startDate: Date,
  endDate: Date,
  weekEndDays: string[]
): number => {
  const weekendDays = weekEndDays.map((day) => dayNameToNumber[day.toLocaleUpperCase()]);

  const start = new Date(startDate);
  const end = new Date(endDate);
  let hours = 0;

  // Iterate from start to end in hourly steps
  while (start < end) {
    // Check if the current day is a weekend day
    const dayOfWeek = start.getDay();
    if (!weekendDays.includes(dayOfWeek)) {
      hours += 1;
    }

    // Move to the next hour
    start.setHours(start.getHours() + 1);
  }

  return hours;
};
export const isValidRequiredDateAndTime = (selectedDate: Date, numberOfDays: number, weekEndDays: string[]) => {
  //const hoursDifference = differenceInHours(selectedDate, new Date(), { roundingMethod: 'ceil' });
  const hoursDifference = getHoursDifferenceExcludingCustomWeekends(new Date(), selectedDate, weekEndDays);
  return !(hoursDifference < numberOfDays * 24);
};
export const mergeDateAndTime = (date: Date, time: string) => {
  const [hours, minutes] = time.split(':').map(Number);
  const mergedDate = new Date(date);
  mergedDate.setHours(hours, minutes, 0, 0);
  return mergedDate;
};
export const isWeekEnd = (startDate: Date, weekEndDays: string[]) => {
  const weekendDays = weekEndDays.map((day) => dayNameToNumber[day.toLocaleUpperCase()]);
  const resultDate = new Date(startDate);
  const dayOfWeek = resultDate.getDay();
  if (weekendDays.includes(dayOfWeek)) return true;
  else return false;
};

export const getFormatedDate = (date: Date): any => {
  // the below line should be used when the date is being stored in DB is the UTC date
  return format(new Date(date), 'dd-MMMMMM-yyyy - hh:mmaa');
};

export const getNumericFormatedDate = (date: Date): any => {
  return format(new Date(date), 'dd/MM/yy - hh:mmaa');
};
export const getCustomFormatedDate = (date: Date, dateFormat: string): any => {
  return format(new Date(date), dateFormat);
};
export const addDaysToDate = (startDate: Date, daysToAdd: number, excludeWeekend: boolean) => {
  if (excludeWeekend) {
    const currentDayOfWeek = startDate.getDay();
    if (currentDayOfWeek === 4 || currentDayOfWeek === 5) daysToAdd += 2;
    else if (currentDayOfWeek === 6) daysToAdd += 1;
  }
  return addHours(addDays(startDate, daysToAdd), 1);
};
